import {
  Component,
  Input,
  OnInit,
} from '@angular/core';
import { FilesService } from 'src/app/core/services/files.service';
import * as mammoth from 'mammoth';

@Component({
  selector: 'file-doc-show-view',
  templateUrl: './file-doc-show-view.component.html',
  styleUrls: ['./file-doc-show-view.component.scss'],
})
export class FileDocShowViewComponent implements OnInit {
  @Input() url: string = null;
  
  info: any = null;
  constructor(
    private readonly filesService: FilesService,
  ) {
  }
  ngOnInit() {
    this.loadContent();
  }

  async loadContent() {
    try {
      const split = this.url.split('/');
      const name = split[split.length - 1];

      let blob = (await this.filesService
        .getFileByArrayBuffer(name)
        .toPromise());

      
      const arrayBuffer = await blob.arrayBuffer();
      const result = await mammoth.convertToHtml({ arrayBuffer });
      this.info = result.value; // HTML limpio

    } catch (error) {
      console.error('Error en el metodo getFileByArrayBuffer:', error);
      throw error;
    }
  }



}